import { CommonModule, TitleCasePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { EditNavigationGuard } from './guard/edit-navigation.guard';
import { LazyLoaderService } from './services/lazy-loader.service';
import { UtilitiesService } from './services/utilities.service';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { LocationService } from './services/location.service';
import { GenericDataService } from './services/generic-data.service';
import { LookUpDataService } from './services/lookup-data.service';
import { ConfirmationModalComponent } from './confirmation/confirmation-modal.component';
import { RolePermissionService } from './authentication/role-permission.service';
import { EnvironmentService } from './services/environment.service';
import { ApplicationContextService } from './services/application-context.service';
import { FrameCommunicationService } from './services/frame-communication.service';
import { CountryService } from './services/country.service';
import { ProductDetailsService } from './services/product-details.service';
import { LocationStorageCoreService } from './services/location-storage-core.service';
import { ErrorComponent } from './communication/error/error.component';
import { LoadingComponent } from './communication/loading/loading.component';
import { PrefixService } from './services/prefix.service';
import { LibTabService } from './services/lib-tabs.service';
import { AddTitleToProductType } from './pipes/add-title-to-producttypes.pipe';
import { SeparateAndApplyTitleCaseToCamelcase } from './pipes/separate-and-apply-titlecase-camelcase.pipe';
import { LeaderboardService } from '../lib/services/leaderboard.service';

@NgModule({
  declarations: [
    LoadingComponent,
    ConfirmationModalComponent,
    ErrorComponent,
    AddTitleToProductType,
    SeparateAndApplyTitleCaseToCamelcase
  ],
  exports: [
    LoadingComponent,
    ConfirmationModalComponent,
    ErrorComponent,
    AddTitleToProductType,
    SeparateAndApplyTitleCaseToCamelcase
  ],
  entryComponents: [
    LoadingComponent,
    ConfirmationModalComponent,
    ErrorComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    MatAutocompleteModule
  ],
  providers: [
    EnvironmentService,
    LookUpDataService,
    UtilitiesService,
    LazyLoaderService,
    GenericDataService,
    EditNavigationGuard,
    RolePermissionService,
    ApplicationContextService,
    FrameCommunicationService,
    ProductDetailsService,
    LocationStorageCoreService,
    PrefixService,
    LibTabService,
    TitleCasePipe
  ]
})
export class LibCoreSharedModule { }
